<template>
  <v-container class="device-info">
    <FormRow 
      label="Device Model"
      :input-payload="model"
      :static-field="true"
    />
    <FormRow 
      label="Config Version"
      :input-payload="version"
      :static-field="true"
    />
  </v-container>
</template>

<script>

// import { Logger } from "aws-amplify";
// const logger = new Logger("device info");

import FormRow from '../components/FormRow.vue';

export default {
  name: 'Info',
  components: {
    FormRow
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    model() {
      const map = {
        'CAMERAMATICS_D700-SD-4G': 'GENIE',
        'CAMERAMATICS_JH4-HD-4G': 'Legacy 4CH',
        'CAMERAMATICS_JH8-HD-4G': 'Legacy 8CH',
        'CAMERAMATICS_JH8_NT-HD-4G': 'NEXTGEN 8CH',
        'CAMERAMATICS_JH4_NT-HD-4G': 'NEXTGEN 4CH',
        'CAMERAMATICS_JI7A-SD-4G': 'JI7A'

      }
      return `${this.config.device_config.target[0].model[0]} (${map[this.config.device_config.target[0].model[0]]})`;
    },
    version() {
      let versionObj = this.config.device_config.version[0];

      return this.parseVersion(versionObj);
    },
    supportedFrom() {
      let fromObj = this.config.device_config.target[0].supportedFW[0].fwRange[0].from[0].version[0];

      return this.parseVersion(fromObj);
    },
    supportedTo(){
      let toObj = this.config.device_config.target[0].supportedFW[0].fwRange[0].to[0].version[0];

      return this.parseVersion(toObj);
    },
    unsupportedFrom() {
      let fromObj = this.config.device_config.target[0].unsupportedFW[0].fwRange[0].from[0].version[0];

      return this.parseVersion(fromObj);
    },
    unsupportedTo() {
      let toObj = this.config.device_config.target[0].unsupportedFW[0].fwRange[0].to[0].version[0];

      return this.parseVersion(toObj);
    }
  },
  methods: {
    parseVersion(target) {
      let num = '';

      for (const key in target) {
        num = num.concat(target[key] + '.');
      }
      // Remove trailing decimal
      num = num.slice(0, -1);

      return num;
    }
  }
}
</script> 